export class State {
    state_name: string;
}
